var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    _vm._g(
      {
        attrs: {
          width: "40",
          height: "40",
          viewBox: "0 0 40 40",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
      },
      _vm.$listeners
    ),
    [
      _c("path", {
        attrs: {
          d: "M25 17a1 1 0 002 0h-2zm-11 0v1h1v-1h-1zm5.5-1a1 1 0 100 2v-2zM29 27h-1 1zm-2-10v-1h-2v1h2zm-13-1h-1v2h1v-2zm-1 14h14v-2H13v2zm14-14h-7.5v2H27v-2zm-14 0V17h2v-.002-.001-.002-.002-.002-.001-.002-.002-.002-.001-.002-.002-.002-.001-.002-.002-.002-.001-.002-.002-.002-.001-.002-.002-.002-.002-.001-.002-.002-.002-.001-.002-.002-.002-.001-.002-.002-.002-.002-.001-.002-.002-.002-.001-.002-.002-.002-.002-.001-.002-.002-.002-.001-.002-.002-.002-.002-.001-.002-.002-.002-.002-.001-.002-.002-.002-.002-.001-.002-.002-.002-.002-.001-.002-.002-.002-.002-.001-.002-.002-.002-.002-.002-.001-.002-.002-.002-.002-.001-.002-.002-.002-.002-.002-.001-.002-.002-.002-.002-.002-.001-.002-.002-.002-.002-.002-.001-.002-.002-.002-.002-.002-.001-.002-.002-.002-.002-.002-.001-.002-.002-.002-.002-.002-.002-.001-.002-.002-.002-.002-.002-.002-.001-.002-.002-.002-.002-.002-.002-.001-.002-.002-.002-.002-.002-.002-.002-.001-.002-.002-.002-.002-.002-.002-.002-.001-.002-.002-.002-.002-.002-.002-.002-.001-.002-.002-.002-.002-.002-.002-.002-.002-.001-.002-.002-.002-.002-.002-.002-.002-.002-.002-.001-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.001-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.001-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.001-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.001-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.001-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.001-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.003-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.003-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.003-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.003-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.003-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.003-.002-.002-.002-.002-.002-.002-.002-.002-.002-.003-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.003-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.003-.002-.002-.002-.002-.002-.002-.002-.003-.002-.002-.002-.002-.002-.002-.002-.002-.002-.003-.002-.002-.002-.002-.002-.002-.003-.002-.002-.002-.002-.002-.002-.002-.002-.003-.002-.002-.002-.002-.002-.002-.003-.002-.002-.002-.002-.002-.002V16h-2zm-3 3v8h2v-8h-2zm20 8v-8h-2v8h2zM20 9a7 7 0 00-7 7h2a5 5 0 015-5V9zm7 21a3 3 0 003-3h-2a1 1 0 01-1 1v2zm-14-2a1 1 0 01-1-1h-2a3 3 0 003 3v-2zm0-12a3 3 0 00-3 3h2a1 1 0 011-1v-2zm14 2a1 1 0 011 1h2a3 3 0 00-3-3v2zm0-2a7 7 0 00-7-7v2a5 5 0 015 5h2z",
          fill: "#AC6ED1",
        },
      }),
      _c("path", {
        attrs: {
          d: "M18 25l4-4M18 21l4 4",
          stroke: "#AC6ED1",
          "stroke-width": "2",
          "stroke-linecap": "round",
        },
      }),
      _c("circle", {
        attrs: {
          cx: "20",
          cy: "20",
          r: "19",
          stroke: "#AC6ED1",
          "stroke-width": "2",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }